/**
 * 広告 (収益モデル) の抽象化。
 *
 * スプリの収益源は広告表示で、ネイティブアプリでは Google AdMob、
 * Web では AdMob と同じ Google のネットワーク (AdSense) を利用する想定。
 *
 * SDK そのものはプラットフォーム依存 (react-native-google-mobile-ads /
 * adsbygoogle.js) なので、ここでは「どこに」「どんな広告を出すか」という
 * 意思決定だけを共通化し、実際の描画は各プラットフォームの実装に委ねる。
 */
export const disabledAdsConfig = { enabled: false, units: {}, testMode: true };
export function shouldShowAd(config, context) {
    if (!config.enabled)
        return false;
    if (!config.units[context.placement])
        return false;
    if (context.placement === "interstitial-settled") {
        return context.justSettled === true;
    }
    // 支出が登録される前は広告を出さない
    return context.expenseCount > 0;
}
/**
 * 広告枠の推奨サイズ。Web / ネイティブ双方で同じ比率を使い、
 * レイアウトシフト (CLS) を避けるために必ず領域を確保する。
 */
export function adSlotSize(format) {
    switch (format) {
        case "rectangle":
            return { width: 300, height: 250 };
        case "interstitial":
            return { width: 320, height: 480 };
        case "banner":
        default:
            return { width: 320, height: 50 };
    }
}
//# sourceMappingURL=ads.js.map